import React from 'react';
import { Tab, TabButtonStyle, TabKeyIdentifierPrefix, TabPanel, TabPanelBorderRadius, TabPanelTheme } from '@apply/components';

export const TabPanelDemo: React.FC<{}> = ({}) => {
    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Tab Panel :</h2>
            <br />
            Blue Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Blue}
                width='100%'
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            Red Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Red}
                width='100%'
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            White Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.White}
                width='100%'
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            Grey Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Gray}
                width='100%'
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            "Whiteout" Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Whiteout}
                width='100%'
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            Blue Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Blue}
                width='100%'
                tabButtonStyle={TabButtonStyle.Condensed}
                tabPanelBorderRadius={TabPanelBorderRadius.Small}
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            Red Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Red}
                width='100%'
                tabButtonStyle={TabButtonStyle.Condensed}
                tabPanelBorderRadius={TabPanelBorderRadius.Small}
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            White Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.White}
                width='100%'
                tabButtonStyle={TabButtonStyle.Condensed}
                tabPanelBorderRadius={TabPanelBorderRadius.Small}
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
            <br />
            Grey Tab Panel
            <br />
            <br />
            <TabPanel
                id='tabPanelDemo'
                theme={TabPanelTheme.Gray}
                width='100%'
                tabButtonStyle={TabButtonStyle.Condensed}
                tabPanelBorderRadius={TabPanelBorderRadius.Small}
            >
                <Tab
                    id='item1'
                    text='Item 1'
                    key={`${TabKeyIdentifierPrefix}1`}
                >
                    This is children for item 1.
                </Tab>
                <Tab
                    id='item2'
                    text='Item 2'
                    key={`${TabKeyIdentifierPrefix}2`}
                >
                    This is children for item 2.
                </Tab>
                <Tab
                    id='item3'
                    text='Item 3'
                    key={`${TabKeyIdentifierPrefix}3`}
                >
                    This is children for item 3.
                </Tab>
                <Tab
                    id='item4'
                    text='Item 4'
                    key={`${TabKeyIdentifierPrefix}4`}
                >
                    This is children for item 4.
                </Tab>
            </TabPanel>
        </div>
    );
};
